import { useTheme } from '@mui/material';
import { createMakeStyles } from 'tss-react';

export const { makeStyles } = createMakeStyles({ useTheme });
